import { store } from "@/main";
import Vue from "vue";
import * as ins_user_info_types from "@/store/constants/ins_user_info_types";
import * as types from "@/store/constants/index_types";
import BindVipConfirmHeader from "@/components/DlalogTsx/BindVip/BindVipConfirm";
import BindVipConfirmContent from "@/components/DlalogTsx/BindVip/BindVipConfirmContent";
import { goToLogin } from "@/utils/router_helper";
import { LoginFromTypes } from "@/utils/router_helper/types";
import { bindInsUserVip } from "@/api/cg/service/user_service";
import ServiceList from "@/services/serviceList";
import Event_bus from "@/utils/event_bus";

export const dialogBindVip = () => {
  try {
    const currentUserInfo =
      store.getters[ins_user_info_types.GETTER_CURRENT_INS_USER_INFO];
    Vue.prototype.$_Dialog.show({
      title: "Confirm Account",
      closable: false,
      headerCustom(ctx: any, r: any) {
        return r(BindVipConfirmHeader, { props: { ctx } });
      },
      contentCustom(ctx: any, r: any) {
        return r(BindVipConfirmContent, { props: { ctx } });
      },
      cancelBtn: {
        text: "NOT THIS ACCOUNT"
      },
      onConfirm: async (done: any) => {
        try {
          done();
          const bindVipResult = await bindUserToVip();
          console.log("bindVipResult", bindVipResult);
        } catch (error) {
          console.log("bind error", error);
        }
      },
      onCancel(done: any) {
        done();
        goToLogin(LoginFromTypes.VIP);
      }
    });
  } catch (e) {
    return Promise.reject(e);
  }
};

export const bindUserToVip = async (silent: boolean = false) => {
  try {
    const masterId = store.getters[types.GETTER_MASTER_USER_ID];
    const currentUserInfo =
      store.getters[ins_user_info_types.GETTER_CURRENT_INS_USER_INFO];
    const bindVipResult: any = await bindInsUserVip(
      currentUserInfo.user_id,
      currentUserInfo.ins_user_info.user_name,
      currentUserInfo.ins_user_info.profile_pic_url,
      masterId
    );
    if (bindVipResult && bindVipResult.bind_result) {
      // 提示绑定成功
      if (!silent) {
        Vue.prototype.$_Toast.show({
          duration: 3000,
          text: `Congratulations，@${currentUserInfo.ins_user_info.user_name} will get 10 bonus followers every day！`
        });
      }
      ServiceList.updateServiceList().then(() => {
        Event_bus.$emit("vip-status-switch");
      });
    }
    return bindVipResult;
  } catch (e) {
    console.log("BIND_INS_USER_TO_VIP error", e);
    return Promise.reject(e);
  }
};
